module.exports = __webpack_public_path__ + "static/media/rionuevo.87ff0b45.PNG";